import { useNavigate } from "react-router-dom";
import { TableItemId } from "../../../../components/tables/TableWidget";
import { receptionRoutes } from "../../../../router/routesConstants";
import { TableItemType } from "../../../../components/tables/tableContext/TableContext";
import CustomButton from "../../../../components/CustomButton";
import { useAppDispatch } from "../../../../redux/hooks";
import { getDeleteProduct } from "../../../../redux/api/receipt.api";
import SvgIcon from "../../../../helpers/SvgIcon";

function ReceivedProductsTableAction({
  itemId,
  status,
}: {
  itemId: TableItemId;
  tableItemData: TableItemType[];
  crudData?: any;
  status: number;
}) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const finalizedReceptions = status >= 5;

  const editProduct = () => {
    navigate(
      `/${receptionRoutes.reception}/${receptionRoutes.receivedProductsEdit}?idProdus=${itemId}`,
    );
  };

  const deleteProduct = () => {
    dispatch(
      getDeleteProduct({
        idProdusReceptie: itemId,
      }),
    );
  };

  return (
    <div className="">
      {!finalizedReceptions && (
        <CustomButton
          className="me-1  mb-2"
          variant="contained"
          color="primary"
          tooltipTitle="Editeaza"
          onClick={editProduct}>
          <SvgIcon type="EDIT" />
        </CustomButton>
      )}
      <CustomButton
        className="me-1  mb-2"
        variant="contained"
        color="error"
        tooltipTitle="Sterge"
        withConfirmationModal={{
          modalTitle: "Stergere produs",
          modalSubtitle: "Esti sigur ca vrei sa stergi produsul?",
          modalLeftButtonColor: "inherit",
          modalRightButtonColor: "error",
          modalRightButtonOnClick: deleteProduct,
        }}>
        <SvgIcon type="DELETE" />
      </CustomButton>
    </div>
  );
}

export default ReceivedProductsTableAction;
